import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize, Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../../store/storeFunctions';

import '../../repi.scss';

const LIMIT = 10;

class RepiContactHistorySection extends React.Component {
    state = {
        expanded: true,
        showAll: false
    };

    render() {
        let data = this.props.data;

        if (!this.props.historyExpanded)
            data = data.filter(contact => contact.flagActual);

        const limited = data.length > LIMIT && !this.state.showAll;
        if (limited)
            data = data.slice(0, LIMIT);

        if (!this.state.expanded) {
            return (
                <tr className={classnames("contact-row", {"row-color": this.props.colorize === true })}>
                    <th className="contact-type primary"><span onClick={() => this.setState({ expanded: true })}><Translate id={this.props.label} /></span></th>
                    <td colSpan={3}>...</td>
                    <td className="count">{this.props.count}</td>
                </tr>
            );
        }

        return(
            <>
                {data.map((x,i) => <tr key={x.contactId} className={classnames("contact-row", {"row-color": this.props.colorize === true, "history-row": !x.flagActual})}>
                    {i === 0
                        ? <th className="contact-type primary "><span onClick={() => this.setState({ expanded: false })}><Translate id={this.props.label} /></span></th>
                        : i === data.length - 1 && data.length > LIMIT && this.state.showAll
                            ? <th className="contact-type">
                                <span className="link-functional print-hidden" onClick={() => this.setState({ showAll: false })}>
                                    <Translate id="Report.Hide" />
                                </span>
                            </th>
                            : <th className="contact-type"/>}
                    <td>{this.props.isPhone && !isNullOrUndefined(x.normalized) ? x.normalized : x.value}</td>
                    <td className="align-right">{x.dataEndDateFormatted}</td>
                    <td className="align-right">{x.referenceCount}</td>
                    {i === 0 ? <td className="count align-right">{this.props.count}</td> : <td/>}
                </tr>)}
                {!this.state.showAll && limited && <tr className={classnames("contact-row", {"row-color": this.props.colorize === true })}>
                    <th className="contact-type">
                        <span className="link-functional print-hidden" onClick={() => this.setState({ showAll: true })}>
                            <Translate id="Report.Common.ShowAll" />
                        </span>
                    </th>
                    <td colSpan={4}>...</td>
                </tr>}
            </>
            
        );
    }
}

export default connect(
    state => state.userContext,
    null
)(withLocalize(withRouter(RepiContactHistorySection)));
